// // export default TimeTableUpdate;
// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { timetableInputs } from "../../formSource";
// import { useLocation, useNavigate } from "react-router-dom";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Button from "@mui/material/Button";
// import Box from "@mui/material/Box";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import Typography from "@mui/material/Typography";
// import Grid from "@mui/material/Grid";
// import { useParams } from "react-router-dom";
// import "./update.scss";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#7451f8",
//     },
//     secondary: {
//       main: "#6c757d",
//     },
//   },
// });

// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];

// const DayOptions = [
//   { value: "Monday", label: "Monday" },
//   { value: "Tuesday", label: "Tuesday" },
//   { value: "Wednesday", label: "Wednesday" },
//   { value: "Thursday", label: "Thursday" },
//   { value: "Friday", label: "Friday" },
//   { value: "Saturday", label: "Saturday" },
// ];

// const startTimeOptions = [
//   { value: "15:00", label: "3:00 PM" },
//   { value: "16:00", label: "4:00 PM" },
//   { value: "17:00", label: "5:00 PM" },
//   { value: "18:00", label: "6:00 PM" },
//   { value: "19:00", label: "7:00 PM" },
//   { value: "20:00", label: "8:00 PM" },
//   { value: "21:00", label: "9:00 PM" },
// ];

// const endTimeOptions = [
//   { value: "16:00", label: "4:00 PM" },
//   { value: "17:00", label: "5:00 PM" },
//   { value: "18:00", label: "6:00 PM" },
//   { value: "19:00", label: "7:00 PM" },
//   { value: "20:00", label: "8:00 PM" },
//   { value: "21:00", label: "9:00 PM" },
//   { value: "22:00", label: "10:00 PM" },
// ];

// const TimeTableUpdate = ({ title }) => {
//   const location = useLocation();
//   const timetableId = location.pathname.match(/\/update-time-table\/(\d+)/)?.[1];
//   const { timeTableMasterId } = useParams();
//   const center_id = localStorage.getItem("center_id");
//   const navigate = useNavigate();

//   const [inputValues, setInputValues] = useState({});
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedDay, setSelectedDay] = useState(null);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [useroptions, setUseroptions] = useState([]);
//   const [selectedsubject, setSelectedsubject] = useState(null);
//   const [Subjectoptions, setSubjectoptions] = useState([]);
//   const [selectedClass, setSelectedClass] = useState(null);
//   const [Classoptions, setClassoptions] = useState([]);
//   const [selectedStartTime, setSelectedStartTime] = useState(null);
//   const [selectedEndTime, setSelectedEndTime] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Please Login first, then you can access this page...");
//     window.location.href = "/";
//   };

//   const checkTimeSlotConflict = async (day, class_id, start_time, end_time, excludeId) => {
//     try {
//       const response = await fetch(
//         `${serverUrl}/check_time_slot_conflict?day=${day}&class_id=${class_id}&start_time=${start_time}&end_time=${end_time}&exclude_id=${excludeId}`
//       );
//       const data = await response.json();
//       return data.hasConflict;
//     } catch (error) {
//       console.error("Error checking time slot conflict:", error);
//       return false;
//     }
//   };

//   useEffect(() => {
//     const fetchTimetable = async () => {
//       try {
//         const response = await fetch(`${serverUrl}/timetable/${timetableId}`, {
//           method: "GET",
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch timetable data");
//         }
//         const data = await response.json();

//         // Set times
//         const startTimeOption = startTimeOptions.find(
//           (option) => option.value === data.data.start_slot_time
//         );
//         setSelectedStartTime(startTimeOption);

//         const endTimeOption = endTimeOptions.find(
//           (option) => option.value === data.data.end_slot_time
//         );
//         setSelectedEndTime(endTimeOption);

//         // Set teacher
//         setSelectedUser({
//           value: data.data.teacher_id,
//           label: data.data.teacher_names
//         });

//         // Set subject
//         setSelectedsubject({
//           value: data.data.subject_id,
//           label: data.data.subject_names
//         });

//         // Set class
//         setSelectedClass({
//           value: data.data.class_id,
//           label: data.data.class_names
//         });

//         // Set status
//         setSelectedStatus(
//           data.data.status === 1
//             ? { value: 1, label: "Active" }
//             : { value: 0, label: "Inactive" }
//         );

//         // Set day
//         setSelectedDay(
//           DayOptions.find(option => option.value === data.data.day) || null
//         );

//         setInputValues(data.data);
//       } catch (error) {
//         console.error(error);
//         toast.error("Failed to fetch timetable data.");
//       }
//     };

//     if (timetableId) {
//       fetchTimetable();
//     }
//   }, [timetableId]);

//   useEffect(() => {
//     user_name();
//     Subject_name();
//     Class_name();
//   }, []);

//   const user_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/teacher_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch teachers");
//       }
//       const data = await response.json();
//       const teachers = data.data.map(item => ({
//         value: item.id,
//         label: item.name
//       }));
//       setUseroptions(teachers);
//     } catch (error) {
//       console.error("Error fetching teachers:", error);
//       toast.error("Failed to fetch teachers data.");
//     }
//   };

//   const Subject_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch subjects");
//       }
//       const data = await response.json();
//       const subjects = data.data.map(item => ({
//         value: item.id,
//         label: item.name
//       }));
//       setSubjectoptions(subjects);
//     } catch (error) {
//       console.error("Error fetching subjects:", error);
//       toast.error("Failed to fetch subjects data.");
//     }
//   };

//   const Class_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch classes");
//       }
//       const data = await response.json();
//       const classes = data.data.map(item => ({
//         value: item.id,
//         label: item.name
//       }));
//       setClassoptions(classes);
//     } catch (error) {
//       console.error("Error fetching classes:", error);
//       toast.error("Failed to fetch classes data.");
//     }
//   };

//   const handleUserSelectChange = async (selectedOption) => {
//     setSelectedUser(selectedOption);
//     setInputValues({
//       ...inputValues,
//       teacher_id: selectedOption.value,
//     });

//     try {
//       const response = await fetch(
//         `${serverUrl}/teacher/user_class_ids/subjects?teacher_id=${selectedOption.value}`
//       );
//       const data = await response.json();

//       const matchedSubject = Subjectoptions.find(
//         (option) => option.value == data.data.subject_id
//       );
//       const matchedClass = Classoptions.find(
//         (option) => option.value === data.data.class_id
//       );

//       setSelectedsubject(matchedSubject);
//       setSelectedClass(matchedClass);

//       setInputValues(prevValues => ({
//         ...prevValues,
//         subject_id: matchedSubject?.value,
//         class_id: matchedClass?.value,
//       }));
//     } catch (error) {
//       console.error("Error fetching subject and class data:", error);
//     }
//   };

//   const handleSubjectSelectChange = (selectedOption) => {
//     setSelectedsubject(selectedOption);
//     setInputValues({
//       ...inputValues,
//       subject_id: selectedOption.value,
//     });
//   };

//   const handleClassSelectChange = (selectedOption) => {
//     setSelectedClass(selectedOption);
//     setInputValues({
//       ...inputValues,
//       class_id: selectedOption.value,
//     });
//   };

//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };

//   const handleDaySelectChange = (selectedOption) => {
//     setSelectedDay(selectedOption);
//     setInputValues({
//       ...inputValues,
//       day: selectedOption.value,
//     });
//   };

//   const handleStartTimeSelectChange = (selectedOption) => {
//     setSelectedStartTime(selectedOption);
//     setInputValues({
//       ...inputValues,
//       start_slot_time: selectedOption.value,
//     });
//   };

//   const handleEndTimeSelectChange = (selectedOption) => {
//     setSelectedEndTime(selectedOption);
//     setInputValues({
//       ...inputValues,
//       end_slot_time: selectedOption.value,
//     });
//   };

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     // Validate required fields
//     if (
//       !inputValues.day ||
//       !inputValues.class_id ||
//       !inputValues.start_slot_time ||
//       !inputValues.end_slot_time
//     ) {
//       toast.error("Please fill all required fields");
//       setIsLoading(false);
//       return;
//     }

//     // Check for time slot conflicts
//     try {
//       const hasConflict = await checkTimeSlotConflict(
//         inputValues.day,
//         inputValues.class_id,
//         inputValues.start_slot_time,
//         inputValues.end_slot_time,
//         timetableId
//       );

//       if (hasConflict) {
//         toast.error("This time slot conflicts with an existing class");
//         setIsLoading(false);
//         return;
//       }

//       const formData = new FormData();
//       formData.append("center_id", center_id);
//       formData.append(
//         "timetable_master_id",
//         localStorage.getItem("timetable_master")
//       );
//       formData.append("teacher_id", inputValues.teacher_id);
//       formData.append("class_id", inputValues.class_id);
//       formData.append("subject_id", inputValues.subject_id);
//       formData.append("day", inputValues.day);
//       formData.append("start_slot_time", inputValues.start_slot_time);
//       formData.append("end_slot_time", inputValues.end_slot_time);
//       formData.append("status", inputValues.status || 1);

//       const response = await fetch(`${serverUrl}/upd_timetable/${timetableId}`, {
//         method: "PUT",
//         body: formData,
//       });

//       const data = await response.json();
//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "Something went wrong.");
//         }
//       } else {
//         toast.success("Timetable updated successfully!");
//         setTimeout(() => {
//           navigate(`/time-table/time-table-slot/${timeTableMasterId}`);
//         }, 1000);
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error("Network error. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="contentWrapper">
//               <Card className="formCard">
//                 <CardContent className="cardContent">
//                   <Typography variant="h5" component="h2" gutterBottom className="formTitle">
//                     {title}
//                   </Typography>
//                   <form onSubmit={handleUpdate} className="responsiveForm">
//                     <Grid container spacing={2}>
//                       {timetableInputs.map((input) => (
//                         <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
//                           <div className="formInput">
//                             <label>{input.label}</label>
//                             {input.fieldName === "teacher_id" ? (
//                               <Select
//                                 options={useroptions}
//                                 value={selectedUser}
//                                 onChange={handleUserSelectChange}
//                                 required
//                                 className="selectInput"
//                                 styles={{
//                                   control: (base) => ({
//                                     ...base,
//                                     minHeight: '46px',
//                                     borderColor: '#e2e8f0',
//                                     '&:hover': {
//                                       borderColor: '#cbd5e0'
//                                     }
//                                   }),
//                                   valueContainer: (base) => ({
//                                     ...base,
//                                     padding: '2px 8px'
//                                   }),
//                                   input: (base) => ({
//                                     ...base,
//                                     margin: '0',
//                                     padding: '0'
//                                   }),
//                                   indicatorsContainer: (base) => ({
//                                     ...base,
//                                     height: '44px'
//                                   })
//                                 }}
//                               />
//                             ) : input.fieldName === "subject_id" ? (
//                               <Select
//                                 options={Subjectoptions}
//                                 value={selectedsubject}
//                                 onChange={handleSubjectSelectChange}
//                                 required
//                                 className="selectInput"
//                                 styles={{
//                                   control: (base) => ({
//                                     ...base,
//                                     minHeight: '46px',
//                                     borderColor: '#e2e8f0',
//                                     '&:hover': {
//                                       borderColor: '#cbd5e0'
//                                     }
//                                   }),
//                                   valueContainer: (base) => ({
//                                     ...base,
//                                     padding: '2px 8px'
//                                   }),
//                                   input: (base) => ({
//                                     ...base,
//                                     margin: '0',
//                                     padding: '0'
//                                   }),
//                                   indicatorsContainer: (base) => ({
//                                     ...base,
//                                     height: '44px'
//                                   })
//                                 }}
//                               />
//                             ) : input.fieldName === "class_id" ? (
//                               <Select
//                                 options={Classoptions}
//                                 value={selectedClass}
//                                 onChange={handleClassSelectChange}
//                                 required
//                                 className="selectInput"
//                                 styles={{
//                                   control: (base) => ({
//                                     ...base,
//                                     minHeight: '46px',
//                                     borderColor: '#e2e8f0',
//                                     '&:hover': {
//                                       borderColor: '#cbd5e0'
//                                     }
//                                   }),
//                                   valueContainer: (base) => ({
//                                     ...base,
//                                     padding: '2px 8px'
//                                   }),
//                                   input: (base) => ({
//                                     ...base,
//                                     margin: '0',
//                                     padding: '0'
//                                   }),
//                                   indicatorsContainer: (base) => ({
//                                     ...base,
//                                     height: '44px'
//                                   })
//                                 }}
//                               />
//                             ) : input.fieldName === "status" ? (
//                               <Select
//                                 options={statusOptions}
//                                 value={selectedStatus}
//                                 onChange={handleStatusSelectChange}
//                                 required
//                                 className="selectInput"
//                                 styles={{
//                                   control: (base) => ({
//                                     ...base,
//                                     minHeight: '46px',
//                                     borderColor: '#e2e8f0',
//                                     '&:hover': {
//                                       borderColor: '#cbd5e0'
//                                     }
//                                   }),
//                                   valueContainer: (base) => ({
//                                     ...base,
//                                     padding: '2px 8px'
//                                   }),
//                                   input: (base) => ({
//                                     ...base,
//                                     margin: '0',
//                                     padding: '0'
//                                   }),
//                                   indicatorsContainer: (base) => ({
//                                     ...base,
//                                     height: '44px'
//                                   })
//                                 }}
//                               />
//                             ) : input.fieldName === "day" ? (
//                               <Select
//                                 options={DayOptions}
//                                 value={selectedDay}
//                                 onChange={handleDaySelectChange}
//                                 required
//                                 className="selectInput"
//                                 styles={{
//                                   control: (base) => ({
//                                     ...base,
//                                     minHeight: '46px',
//                                     borderColor: '#e2e8f0',
//                                     '&:hover': {
//                                       borderColor: '#cbd5e0'
//                                     }
//                                   }),
//                                   valueContainer: (base) => ({
//                                     ...base,
//                                     padding: '2px 8px'
//                                   }),
//                                   input: (base) => ({
//                                     ...base,
//                                     margin: '0',
//                                     padding: '0'
//                                   }),
//                                   indicatorsContainer: (base) => ({
//                                     ...base,
//                                     height: '44px'
//                                   })
//                                 }}
//                               />
//                             ) : input.fieldName === "start_slot_time" ? (
//                               <Select
//                                 options={startTimeOptions}
//                                 value={selectedStartTime}
//                                 onChange={handleStartTimeSelectChange}
//                                 required
//                                 className="selectInput"
//                                 styles={{
//                                   control: (base) => ({
//                                     ...base,
//                                     minHeight: '46px',
//                                     borderColor: '#e2e8f0',
//                                     '&:hover': {
//                                       borderColor: '#cbd5e0'
//                                     }
//                                   }),
//                                   valueContainer: (base) => ({
//                                     ...base,
//                                     padding: '2px 8px'
//                                   }),
//                                   input: (base) => ({
//                                     ...base,
//                                     margin: '0',
//                                     padding: '0'
//                                   }),
//                                   indicatorsContainer: (base) => ({
//                                     ...base,
//                                     height: '44px'
//                                   })
//                                 }}
//                               />
//                             ) : input.fieldName === "end_slot_time" ? (
//                               <Select
//                                 options={endTimeOptions}
//                                 value={selectedEndTime}
//                                 onChange={handleEndTimeSelectChange}
//                                 required
//                                 className="selectInput"
//                                 styles={{
//                                   control: (base) => ({
//                                     ...base,
//                                     minHeight: '46px',
//                                     borderColor: '#e2e8f0',
//                                     '&:hover': {
//                                       borderColor: '#cbd5e0'
//                                     }
//                                   }),
//                                   valueContainer: (base) => ({
//                                     ...base,
//                                     padding: '2px 8px'
//                                   }),
//                                   input: (base) => ({
//                                     ...base,
//                                     margin: '0',
//                                     padding: '0'
//                                   }),
//                                   indicatorsContainer: (base) => ({
//                                     ...base,
//                                     height: '44px'
//                                   })
//                                 }}
//                               />
//                             ) : (
//                               <input
//                                 type={input.type}
//                                 placeholder={input.placeholder}
//                                 name={input.fieldName}
//                                 value={inputValues[input.fieldName] || ""}
//                                 onChange={handleInputChange}
//                                 required
//                               />
//                             )}
//                           </div>
//                         </Grid>
//                       ))}
//                     </Grid>
//                     <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
//                       <Button
//                         variant="outlined"
//                         color="secondary"
//                         onClick={() => navigate(`/time-table/time-table-slot/${timeTableMasterId}`)}
//                         sx={{ minWidth: '120px', height: '42px' }}
//                         disabled={isLoading}
//                       >
//                         Cancel
//                       </Button>
//                       <Button
//                         type="submit"
//                         variant="contained"
//                         color="primary"
//                         sx={{ minWidth: '150px', height: '42px' }}
//                         disabled={isLoading}
//                       >
//                         {isLoading ? "Updating..." : "Update Timetable"}
//                       </Button>
//                     </Box>
//                   </form>
//                 </CardContent>
//               </Card>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </ThemeProvider>
//   );
// };

// export default TimeTableUpdate;

import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { timetableInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useParams } from "react-router-dom";
import "./update.scss";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const DayOptions = [
  { value: "Monday", label: "Monday" },
  { value: "Tuesday", label: "Tuesday" },
  { value: "Wednesday", label: "Wednesday" },
  { value: "Thursday", label: "Thursday" },
  { value: "Friday", label: "Friday" },
  { value: "Saturday", label: "Saturday" },
];

const startTimeOptions = [
  { value: "15:00", label: "3:00 PM" },
  { value: "16:00", label: "4:00 PM" },
  { value: "17:00", label: "5:00 PM" },
  { value: "18:00", label: "6:00 PM" },
  { value: "19:00", label: "7:00 PM" },
  { value: "20:00", label: "8:00 PM" },
  { value: "21:00", label: "9:00 PM" },
];

const endTimeOptions = [
  { value: "16:00", label: "4:00 PM" },
  { value: "17:00", label: "5:00 PM" },
  { value: "18:00", label: "6:00 PM" },
  { value: "19:00", label: "7:00 PM" },
  { value: "20:00", label: "8:00 PM" },
  { value: "21:00", label: "9:00 PM" },
  { value: "22:00", label: "10:00 PM" },
];

const TimeTableUpdate = ({ title }) => {
  const location = useLocation();
  const timetableId = location.pathname.match(
    /\/update-time-table\/(\d+)/
  )?.[1];
  const { timeTableMasterId } = useParams();
  const center_id = localStorage.getItem("center_id");
  const navigate = useNavigate();

  const [inputValues, setInputValues] = useState({ is_assessment: 0 });
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [useroptions, setUseroptions] = useState([]);
  const [selectedsubject, setSelectedsubject] = useState(null);
  const [Subjectoptions, setSubjectoptions] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [Classoptions, setClassoptions] = useState([]);
  const [selectedStartTime, setSelectedStartTime] = useState(null);
  const [selectedEndTime, setSelectedEndTime] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isAssessment, setIsAssessment] = useState(false);
  let [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please Login first, then you can access this page...");
    window.location.href = "/";
  };

  const checkTimeSlotConflict = async (
    day,
    class_id,
    start_time,
    end_time,
    excludeId
  ) => {
    try {
      const response = await fetch(
        `${serverUrl}/check_time_slot_conflict?day=${day}&class_id=${class_id}&start_time=${start_time}&end_time=${end_time}&exclude_id=${excludeId}`
      );
      const data = await response.json();
      return data.hasConflict;
    } catch (error) {
      console.error("Error checking time slot conflict:", error);
      return false;
    }
  };

  const checkTeacherConflict = async (
    day,
    teacher_id,
    start_time,
    end_time,
    excludeId
  ) => {
    try {
      const response = await fetch(
        `${serverUrl}/check_teacher_conflict?day=${day}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&exclude_id=${excludeId}`
      );
      const data = await response.json();
      return data.hasConflict;
    } catch (error) {
      console.error("Error checking teacher conflict:", error);
      return false;
    }
  };

  useEffect(() => {
    const fetchTimetable = async () => {
      try {
        const response = await fetch(`${serverUrl}/timetable/${timetableId}`, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch timetable data");
        }
        const data = await response.json();

        // Set assessment status
        const assessmentStatus = data.data.is_assessment === 1;
        setIsAssessment(assessmentStatus);
        setInputValues((prev) => ({
          ...prev,
          is_assessment: data.data.is_assessment,
        }));

        // Set times
        const startTimeOption = startTimeOptions.find(
          (option) => option.value === data.data.start_slot_time
        );
        setSelectedStartTime(startTimeOption);

        const endTimeOption = endTimeOptions.find(
          (option) => option.value === data.data.end_slot_time
        );
        setSelectedEndTime(endTimeOption);

        // Set teacher (only if not assessment)
        if (!assessmentStatus && data.data.teacher_id) {
          setSelectedUser({
            value: data.data.teacher_id,
            label: data.data.teacher_name || data.data.teacher_names,
          });
        }

        // Set subject (only if not assessment)
        if (!assessmentStatus && data.data.subject_id) {
          setSelectedsubject({
            value: data.data.subject_id,
            label: data.data.subject_name || data.data.subject_names,
          });
        }

        // Set class
        setSelectedClass({
          value: data.data.class_id,
          label: data.data.class_name || data.data.class_names,
        });

        // Set status
        setSelectedStatus(
          data.data.status === 1
            ? { value: 1, label: "Active" }
            : { value: 0, label: "Inactive" }
        );

        // Set day
        setSelectedDay(
          DayOptions.find((option) => option.value === data.data.day) || null
        );

        setInputValues((prev) => ({
          ...prev,
          ...data.data,
          teacher_id: assessmentStatus ? null : data.data.teacher_id,
          subject_id: assessmentStatus ? null : data.data.subject_id,
        }));
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch timetable data.");
      }
    };

    if (timetableId) {
      fetchTimetable();
    }
  }, [timetableId]);

  useEffect(() => {
    user_name();
    Subject_name();
    Class_name();
  }, []);

  useEffect(() => {
    if (isAssessment) {
      // Clear teacher and subject when it's an assessment
      setSelectedUser(null);
      setSelectedsubject(null);
      setInputValues((prev) => ({
        ...prev,
        teacher_id: null,
        subject_id: null,
      }));
    }
  }, [isAssessment]);

  const user_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/teacher_ids/${center_id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch teachers");
      }
      const data = await response.json();
      const teachers = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setUseroptions(teachers);
    } catch (error) {
      console.error("Error fetching teachers:", error);
      toast.error("Failed to fetch teachers data.");
    }
  };

  const Subject_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch subjects");
      }
      const data = await response.json();
      const subjects = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setSubjectoptions(subjects);
    } catch (error) {
      console.error("Error fetching subjects:", error);
      toast.error("Failed to fetch subjects data.");
    }
  };

  const Class_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch classes");
      }
      const data = await response.json();
      const classes = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setClassoptions(classes);
    } catch (error) {
      console.error("Error fetching classes:", error);
      toast.error("Failed to fetch classes data.");
    }
  };

  const handleAssessmentChange = (e) => {
    const isChecked = e.target.checked;
    setIsAssessment(isChecked);
    setInputValues({
      ...inputValues,
      is_assessment: isChecked ? 1 : 0,
    });
  };

  const handleUserSelectChange = async (selectedOption) => {
    setSelectedUser(selectedOption);
    setInputValues({
      ...inputValues,
      teacher_id: selectedOption.value,
    });

    try {
      const response = await fetch(
        `${serverUrl}/teacher/user_class_ids/subjects?teacher_id=${selectedOption.value}`
      );
      const data = await response.json();

      const matchedSubject = Subjectoptions.find(
        (option) => option.value == data.data.subject_id
      );
      const matchedClass = Classoptions.find(
        (option) => option.value === data.data.class_id
      );

      setSelectedsubject(matchedSubject);
      setSelectedClass(matchedClass);

      setInputValues((prevValues) => ({
        ...prevValues,
        subject_id: matchedSubject?.value,
        class_id: matchedClass?.value,
      }));
    } catch (error) {
      console.error("Error fetching subject and class data:", error);
    }
  };

  const handleSubjectSelectChange = (selectedOption) => {
    setSelectedsubject(selectedOption);
    setInputValues({
      ...inputValues,
      subject_id: selectedOption.value,
    });
  };

  const handleClassSelectChange = (selectedOption) => {
    setSelectedClass(selectedOption);
    setInputValues({
      ...inputValues,
      class_id: selectedOption.value,
    });
  };

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues({
      ...inputValues,
      status: selectedOption.value,
    });
  };

  const handleDaySelectChange = (selectedOption) => {
    setSelectedDay(selectedOption);
    setInputValues({
      ...inputValues,
      day: selectedOption.value,
    });
  };

  const handleStartTimeSelectChange = (selectedOption) => {
    setSelectedStartTime(selectedOption);
    setInputValues({
      ...inputValues,
      start_slot_time: selectedOption.value,
    });
  };

  const handleEndTimeSelectChange = (selectedOption) => {
    setSelectedEndTime(selectedOption);
    setInputValues({
      ...inputValues,
      end_slot_time: selectedOption.value,
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Validate required fields
    if (
      !inputValues.day ||
      !inputValues.class_id ||
      !inputValues.start_slot_time ||
      !inputValues.end_slot_time
    ) {
      toast.error("Please fill all required fields");
      setIsLoading(false);
      return;
    }

    // Validation for non-assessment entries
    if (!isAssessment) {
      if (!inputValues.teacher_id || !inputValues.subject_id) {
        toast.error(
          "Teacher and Subject are required for non-assessment entries"
        );
        setIsLoading(false);
        return;
      }
    }

    try {
      // Check for time slot conflicts
      const hasTimeConflict = await checkTimeSlotConflict(
        inputValues.day,
        inputValues.class_id,
        inputValues.start_slot_time,
        inputValues.end_slot_time,
        timetableId
      );

      if (hasTimeConflict) {
        toast.error("This time slot conflicts with an existing class");
        setIsLoading(false);
        return;
      }

      // Check for teacher conflicts (only for non-assessment entries)
      if (!isAssessment && inputValues.teacher_id) {
        const hasTeacherConflict = await checkTeacherConflict(
          inputValues.day,
          inputValues.teacher_id,
          inputValues.start_slot_time,
          inputValues.end_slot_time,
          timetableId
        );

        if (hasTeacherConflict) {
          toast.error("Teacher already has a class scheduled during this time");
          setIsLoading(false);
          return;
        }
      }

      // Prepare form data
      const formData = new FormData();
      formData.append("center_id", center_id);
      formData.append(
        "timetable_master_id",
        localStorage.getItem("timetable_master")
      );
      formData.append("teacher_id", isAssessment ? "" : inputValues.teacher_id);
      formData.append(
        "class_id",
        localStorage.getItem("timetable_master_class_id")
      );
      formData.append("subject_id", isAssessment ? "" : inputValues.subject_id);
      formData.append("is_assessment", inputValues.is_assessment);
      formData.append("day", inputValues.day);
      formData.append("start_slot_time", inputValues.start_slot_time);
      formData.append("end_slot_time", inputValues.end_slot_time);
      formData.append("status", inputValues.status || 1);

      const response = await fetch(
        `${serverUrl}/upd_timetable/${timetableId}`,
        {
          method: "PUT",
          body: formData,
        }
      );

      const data = await response.json();
      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Timetable updated successfully!");
        setTimeout(() => {
          navigate(`/time-table/time-table-slot/${timeTableMasterId}`);
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {/* Assessment Checkbox */}
                      <Grid item xs={12}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={isAssessment}
                                onChange={handleAssessmentChange}
                                name="is_assessment"
                                color="primary"
                              />
                            }
                            label="This is an assessment slot (Teacher and Subject will be disabled)"
                          />
                        </FormGroup>
                      </Grid>

                      {timetableInputs.map((input) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          key={input.id}
                          className="formGridItem"
                        >
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "teacher_id" ? (
                              <Select
                                options={useroptions}
                                value={selectedUser}
                                onChange={handleUserSelectChange}
                                required={!isAssessment}
                                isDisabled={isAssessment}
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                    backgroundColor: isAssessment
                                      ? "#f5f5f5"
                                      : "white",
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "subject_id" ? (
                              <Select
                                options={Subjectoptions}
                                value={selectedsubject}
                                onChange={handleSubjectSelectChange}
                                required={!isAssessment}
                                isDisabled={isAssessment}
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                    backgroundColor: isAssessment
                                      ? "#f5f5f5"
                                      : "white",
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "class_id" ? (
                              <Select
                                options={Classoptions}
                                value={selectedClass}
                                onChange={handleClassSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "status" ? (
                              <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={handleStatusSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "day" ? (
                              <Select
                                options={DayOptions}
                                value={selectedDay}
                                onChange={handleDaySelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "start_slot_time" ? (
                              <Select
                                options={startTimeOptions}
                                value={selectedStartTime}
                                onChange={handleStartTimeSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : input.fieldName === "end_slot_time" ? (
                              <Select
                                options={endTimeOptions}
                                value={selectedEndTime}
                                onChange={handleEndTimeSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "46px",
                                    borderColor: "#e2e8f0",
                                    "&:hover": {
                                      borderColor: "#cbd5e0",
                                    },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "2px 8px",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: "0",
                                    padding: "0",
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: "44px",
                                  }),
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() =>
                          navigate(
                            `/time-table/time-table-slot/${timeTableMasterId}`
                          )
                        }
                        sx={{ minWidth: "120px", height: "42px" }}
                        disabled={isLoading}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                        disabled={isLoading}
                      >
                        {isLoading ? "Updating..." : "Update Timetable"}
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default TimeTableUpdate;
